'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.areValueSetsEquivalent = areValueSetsEquivalent;
exports.areNodesEquivalent = areNodesEquivalent;
exports.areChildNodesEquivalent = areChildNodesEquivalent;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Two nodes are equivalent if:
//      They share the same data node values
//      They have children that are pairwise equivalent
//      If children order matters, then the pairwise equivalent children are at the same location

// Two value sets are equivalent if:
//      They have identical values OR
//          are the same value set type and
//          have equivalent values determined on an ad-hoc basis

function areValueSetsEquivalent(valueset1, valueset2) {
    // checks should be least expensive to most expensive
    return [areValueSetTypesEqual, areValueSetDataEqual].every(function (check) {
        return check(valueset1, valueset2);
    });
}

function areNodesEquivalent(node1, node2) {
    // checks should be least expensive to most expensive
    return [areNodeTypesEqual, areNumberOfChildrenEqual, areNodeDataEqual, areChildrenEqual].every(function (check) {
        return check(node1, node2);
    });
}

function areChildNodesEquivalent(node1, node2) {
    // checks should be least expensive to most expensive
    return [areNumberOfChildrenEqual, areChildrenEqual].every(function (check) {
        return check(node1, node2);
    });
}

function areNodeTypesEqual(node1, node2) {
    return node1.type === node2.type;
}

function areNumberOfChildrenEqual(node1, node2) {
    return node1.children.length === node2.children.length;
}

function areNodeDataEqual(node1, node2) {
    return _lodash2.default.isEqualWith(node1.data, node2.data, areValuesEqual);
}

// right now assumes that children are unordered for every node; there are no nodes that
// currently have an order requirement
function areChildrenEqual(node1, node2) {
    if (node1.children.length === 0) {
        return true;
    }
    return node1.children.reduce(function (isMatching, nextChild) {
        if (isMatching === false) {
            return false;
        }
        return node2.children.some(function (otherChild) {
            return areNodesEquivalent(nextChild, otherChild);
        });
    }, true);
}

function areValuesEqual(value1, value2) {
    if (isValueSet(value1) && isValueSet(value2)) {
        return areValueSetsEquivalent(value1, value2);
    }
    if (!_lodash2.default.isObject(value1) || !_lodash2.default.isObject(value2)) {
        return _lodash2.default.isEqual(value1, value2);
    }
    if (_lodash2.default.size(value1) !== _lodash2.default.size(value2)) {
        return false;
    }
    var keys = _lodash2.default.union((0, _keys2.default)(value1), (0, _keys2.default)(value2));
    return _lodash2.default.every(keys, function (key) {
        return areValuesEqual(value1[key], value2[key]);
    });
}

function areValueSetDataEqual(valueset1, valueset2) {
    if (!valueset1._data || !valueset2._data) {
        return false;
    }
    return _lodash2.default.isEqual(valueset1._data, valueset2._data);
}

function isValueSet(value) {
    return Boolean(value && value._isValueSet);
}

function areValueSetTypesEqual(valueset1, valueset2) {
    return valueset1.type === valueset2.type;
}